import React from "react";
import { BiStoreAlt } from "react-icons/bi";
import { GrAnnounce } from "react-icons/gr";
import { Dropdown, Tag, Tooltip } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const OutletCard = ({
  outlet,
  businessName,
  address,
  created,
  approveStatus,
  announce,
  stampCodes = [],
  onEdit,
  onDelete,
  onAddStampDevice,
  menuOptions = [],
  showAddStampDevice = false,
  showDelete = true,
  showOptions = false,
  onEditLabel,
}) => {
  const { t } = useTranslation();

  const getStatusColor = (status) => {
    switch (status) {
      case "ACCEPTED":
        return "green";
      case "PENDING":
        return "orange";
      case "REJECTED":
        return "red";
      default:
        return "gray";
    }
  };

  const defaultMenu = [
    {
      key: "edit",
      label: onEditLabel || t("edit"),
      onClick: () => onEdit?.(),
    },
    showAddStampDevice && {
      key: "addStamp",
      label: t("add_stamp_code"),
      onClick: onAddStampDevice,
    },
    showDelete && {
      key: "delete",
      label: t("delete"),
      danger: true,
      onClick: onDelete,
    },
  ].filter(Boolean);

  const menuItems = [...defaultMenu, ...menuOptions].filter(Boolean);

  return (
    <div className="outlet-card">
      {announce ? (
        <GrAnnounce className="outlet-card-icon" size={48} />
      ) : (
        <BiStoreAlt className="outlet-card-icon" size={48} />
      )}

      <div className="outlet-card-content">
        <div className="header">
          <h4 className="active">{businessName}</h4>
          {showOptions && (
            <Dropdown trigger={["click"]} menu={{ items: menuItems }}>
              <MoreOutlined />
            </Dropdown>
          )}
        </div>

        {address && (
          <p>
            📍 {address.house_number}, {address.street_name}, {address.town}{" "}
            {address.postal_code}
          </p>
        )}

        <p>
          🗓️ {t("created")}:{" "}
          <span className="active">
            {dayjs(created).format("MMMM D, YYYY")}
          </span>
        </p>

        {approveStatus && (
          <p>
            {t("status")}:{" "}
            <Tag color={getStatusColor(approveStatus)}>{approveStatus}</Tag>
          </p>
        )}

        {stampCodes?.length > 0 && (
          <div className="outlet-stamps">
            <span>{t("stamps")}:</span>
            <div className="outlet-stamps-tags">
              {stampCodes.map((code, i) => (
                <Tooltip title={code} key={i}>
                  <Tag color="#f11e69">{code}</Tag>
                </Tooltip>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OutletCard;
